import { getConfigForMeasuredTest } from 'Components/Worksheets/Config';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from '../../../QestIds';
import { NuclearDensityGaugeMode } from '../../types';
import getLabelConfig from './labelConfig';

const probeCountConfig = { uom: '', format: { nearest: 1 } };
const densityConfig = { uom: 'lb/ft³', format: { nearest: 0.1 } };

const config = (_: string) =>
  mergeConfig(
    {
      ...getConfigForMeasuredTest(qestIds.oversizeCorrection.ARIZ_227e, 'data.OversizeCorrectionTest'),
      'data.Preparation.DensityStandardCount': probeCountConfig,
      'data.Preparation.MoistureStandardCount': probeCountConfig,
      'data.Measurements.Depth': { uom: 'in', format: { nearest: 0.1 } },
      'data.Measurements.NuclearDensityGaugeMode': {
        options: [
          { label: 'Backscatter', value: NuclearDensityGaugeMode.Backscatter },
          { label: 'Direct Transmission', value: NuclearDensityGaugeMode.DirectTransmission },
        ],
      },

      'data.Measurements.Readings.DensityTestCount': probeCountConfig,
      'data.Measurements.Readings.MoistureTestCount': probeCountConfig,
      'data.Measurements.Readings.WetDensity': densityConfig,
      'data.Measurements.Readings.MoistureDensity': densityConfig,
      'data.Measurements.Readings.MoistureDensityMeasured': densityConfig,
      'data.Measurements.Readings.DryDensity': densityConfig,
      'data.Measurements.Readings.MoistureContent': { format: { nearest: 0.1 } },
      'data.Measurements.Readings.MoistureContentMeasured': { format: { nearest: 0.1 } },
      'data.Measurements.AverageReadings.DensityTestCount': probeCountConfig,
      'data.Measurements.AverageReadings.MoistureTestCount': probeCountConfig,
      'data.Measurements.AverageReadings.WetDensity': densityConfig,
      'data.Measurements.AverageReadings.MoistureDensity': densityConfig,
      'data.Measurements.AverageReadings.DryDensity': densityConfig,
      'data.Measurements.AverageReadings.MoistureContent': { format: { nearest: 0.1 } },
      'data.Results.MaximumDryDensity': densityConfig,
      'data.Results.OptimumMoistureContent': { format: { nearest: 0.1 } },
      'data.Results.InsituWetDensity': densityConfig,
      'data.Results.InsituMoistureContent': { format: { nearest: 0.1 } },
      'data.Results.InsituDryDensity': densityConfig,
      'data.Results.RelativeCompaction': { format: { nearest: 0.1 } },
      'data.Results.MoistureVariation': { format: { nearest: 0.1 } },
      'data.ReferenceDensityResults.MaximumDryDensity': densityConfig,
      'data.ReferenceDensityResults.OptimumMoistureContent': { format: { nearest: 0.1 } },
      'data.Retest.OriginalTest.ImportedTest.Results.RelativeCompaction': { format: { nearest: 0.1 } },
      'data.Retest.OriginalTest.ImportedTest.Results.MoistureVariation': { format: { nearest: 0.1 } },
    },
    getLabelConfig('data')
  );

export default {
  [qestIds.nuclearFieldDensity.ARIZ_235.rev1992]: config,
};
